module.exports = __webpack_public_path__ + "img/dku.00101.69e8edf3.png";